import type { CSSProperties } from 'react';

export const T = {
  bg: '#09090B',
  surface: '#111115',
  surfaceUp: '#18181E',
  border: '#222228',
  borderMid: '#2E2E38',
  accent: 'oklch(0.72 0.22 30)',
  accentDim: 'oklch(0.55 0.18 30)',
  accentSoft: 'oklch(0.72 0.22 30 / 0.1)',
  accentMid: 'oklch(0.72 0.22 30 / 0.2)',
  text: '#F0EEE9',
  textSec: '#85848F',
  textMuted: '#44444E',
  success: 'oklch(0.72 0.18 145)',
  successSoft: 'oklch(0.72 0.18 145 / 0.1)',
  warn: 'oklch(0.80 0.16 75)',
  warnSoft: 'oklch(0.80 0.16 75 / 0.1)',
  error: 'oklch(0.68 0.2 25)',
  errorSoft: 'oklch(0.68 0.2 25 / 0.1)',
} as const;

export const btn: Record<'primary' | 'outline' | 'ghost', CSSProperties> = {
  primary: {
    background: T.accent,
    border: 'none',
    borderRadius: 4,
    padding: '13px 28px',
    color: '#000',
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'DM Sans, sans-serif',
    letterSpacing: '0.01em',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  outline: {
    background: 'transparent',
    border: `1px solid ${T.border}`,
    borderRadius: 4,
    padding: '12px 24px',
    color: T.text,
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: 'DM Sans, sans-serif',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  ghost: {
    background: 'transparent',
    border: 'none',
    color: T.textSec,
    fontSize: 13,
    fontWeight: 500,
    cursor: 'pointer',
    fontFamily: 'DM Sans, sans-serif',
    padding: '6px 0',
  },
};
